import nav from "./nav.json";

/** Navigation groups — icons resolved in docNavIcons.js */
export const DOC_NAV = nav.groups;

export const DOC_NAV_MANIFEST = nav;
